import React from "react";
import Reveal from "./Reveal";

const principles = [
  {
    num: "I.",
    title: "Real-world insight.",
    copy:
      "Decades of running businesses — from mints to marketing firms — shape every call. Theory is cheap; lived experience compounds.",
  },
  {
    num: "II.",
    title: "Bold moves.",
    copy:
      "I'd rather build something honest and hard than pivot forever. If an idea has legs, give it room to run.",
  },
  {
    num: "III.",
    title: "Values, profitably.",
    copy:
      "Good business doesn't require compromise on principle. The two sharpen each other when done right.",
  },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 lg:py-40 border-t border-gold-deep/40 z-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="overline mb-6">About Ryan</div>
              <h2 className="heading-section text-5xl lg:text-7xl text-white leading-[0.95]">
                Builder.
                <br />
                <span className="italic gold-gradient-text">Operator.</span>
                <br />
                Optimist.
              </h2>
            </Reveal>

            <Reveal delay={120}>
              <div className="mt-10 space-y-5 body-copy text-base">
                <p>
                  Entrepreneurs choose to work with me because I combine decades of diverse
                  business experience with a proven ability to turn innovative ideas into
                  profitable, enduring enterprises.
                </p>
                <p>
                  I've run mints and marketing agencies, launched crypto and connected
                  communities. Each chapter was research for the next.
                </p>
                <p className="text-white/90">
                  Today I spend my time on three things — and mentor founders pursuing something
                  honest and hard.
                </p>
              </div>
            </Reveal>

            <Reveal delay={240}>
              <div className="mt-10 flex items-center gap-4 flex-wrap">
                <a href="#book" className="btn-primary" data-testid="about-cta">
                  Book a Call
                </a>
                <a
                  href="#contact"
                  className="btn-secondary"
                  data-testid="about-cta-secondary"
                >
                  Send a Message
                </a>
                <a
                  href="https://ryanbest.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/60 hover:text-gold transition-colors"
                  data-testid="about-legacy-link"
                >
                  Full Archive →
                </a>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={200}>
              <div className="grid gap-px bg-gold-deep/30 border border-gold-deep/30">
                {principles.map((pr) => (
                  <div
                    key={pr.num}
                    className="p-8 lg:p-12 bg-[#070707] hover:bg-[#0c0a06] transition-colors duration-500 group"
                    data-testid={`principle-${pr.num.replace(".", "")}`}
                  >
                    <div className="flex items-start gap-8 lg:gap-12">
                      <span className="font-serif text-gold text-5xl lg:text-7xl leading-none w-24 shrink-0">
                        {pr.num}
                      </span>
                      <div>
                        <h3 className="heading-section text-3xl lg:text-4xl text-white mb-3 group-hover:text-gold-light transition-colors">
                          {pr.title}
                        </h3>
                        <p className="body-copy text-base max-w-xl">{pr.copy}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>

            <Reveal delay={320}>
              <blockquote className="mt-10 border-l-2 border-gold pl-8 py-2">
                <p className="font-serif italic text-2xl lg:text-3xl text-white/90 leading-snug">
                  "We didn't launch STBL to create another cryptocurrency — we launched it to
                  bring back confidence in money, backed by metals that have stood the test of
                  time."
                </p>
                <footer className="mt-4 font-mono text-[10px] uppercase tracking-[0.28em] text-gold/80">
                  — Ryan Best · Founder's Note
                </footer>
              </blockquote>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
